import { RouteInterface } from "src/common";
import config from "src/config";
import { NotFoundPage } from "src/pages/global/notFound/notFound.page";
import CheckoutPage from "../checkout/checkout.page";
import CheckoutExecutePaymentPage from "../checkout/checkoutExecutePayment.page";
import CheckoutExecutePaymentWithInstallmentsPage from "../checkout/checkoutExecutePaymentWithInstallments.page";
import CheckoutFailurePage from "../checkout/checkoutFailure.page";
import CheckoutPaymentSentPage from "../checkout/checkoutPaymentSent.page";
import CheckoutPaymentSentWithInstallmentsPage from "../checkout/checkoutPaymentSentWithInstallments.page";
import CheckoutSuccessPage from "../checkout/checkoutSuccess.page";
import CustomerPage from "../customer/customer.page";
import CustomerWithDatePage from "../customer/customerWithDate.page";
import OfferPage from "../offers/offer.page";
import OffersPage from "../offers/offers.page";
import RootPage from "../root.page";
import SoPage from "../so/so.page";
import MboPage from "../mbo/mbo.page";
import MboThankYouPage from "../mbo/mboThankYou.page";
import CustomerWithDateNewPage from "../customer/customerWithDateNew.page";

import { AppRoutes } from "./app.routes";

const AppRouting: Array<RouteInterface> = [
  {
    path: `${AppRoutes.ROOT.fullPath}`,
    element: () => config.REACT_APP_IS_DEV === 'true' ? RootPage() : NotFoundPage(),
    functions: []
  },
  {
    path: `${AppRoutes.CUSTOMER_DATE.fullPath}/:birthDate`,
    element: CustomerWithDatePage,
    functions: [],
    pageName: 'Personal Data Step 2'
  },
  {
    path: `${AppRoutes.CUSTOMER_DATE_NEW.fullPath}/:birthDate`,
    element: CustomerWithDateNewPage,
    functions: [],
    pageName: 'Personal Data Step 2 New'
  },
  {
    path: `${AppRoutes.CUSTOMER.fullPath}`,
    element: CustomerPage,
    functions: [],
    pageName: 'Personal Data Step 1'
  },
  {
    path: `${AppRoutes.OFFERS.fullPath}`,
    element: OffersPage,
    functions: [],
    pageName: 'Offers'
  },
  {
    path: `${AppRoutes.OFFER.fullPath}/:offerId`,
    element: OfferPage,
    functions: [],
    pageName: 'Contractor'
  },
  {
    path: `${AppRoutes.SO.fullPath}/:soId`,
    element: SoPage,
    functions: [],
    pageName: ''
  },
  {
    path: `${AppRoutes.CHECKOUT.fullPath}/:offerId`,
    element: CheckoutPage,
    functions: [],
    pageName: 'Choose Payment'
  },
  {
    path: `${AppRoutes.CHECKOUT_SUCCESS.fullPath}`,
    element: CheckoutSuccessPage,
    functions: [],
    pageName: 'Confirmation'
  },
  {
    path: `${AppRoutes.CHECKOUT_FAILURE.fullPath}`,
    element: CheckoutFailurePage,
    functions: [],
    pageName: 'Payment Error'
  },
  {
    path: `${AppRoutes.CHECKOUT_PAYMENT_SENT.fullPath}/:offerId`,
    element: CheckoutPaymentSentPage,
    functions: [],
    pageName: 'Plaćanje - Uplata jednokratno'
  },
  {
    path: `${AppRoutes.CHECKOUT_EXECUTE_PAYMENT.fullPath}/:offerId`,
    element: CheckoutExecutePaymentPage,
    functions: [],
    pageName: 'Skeniraj - Uplata jednokratno'
  },
  {
    path: `${AppRoutes.CHECKOUT_PAYMENT_SENT_INSTALLMENTS.fullPath}/:offerId`,
    element: CheckoutPaymentSentWithInstallmentsPage,
    functions: [],
    pageName: 'Plaćanje - Uplata na rate'
  },
  {
    path: `${AppRoutes.CHECKOUT_EXECUTE_PAYMENT_INSTALLMENTS.fullPath}/:offerId`,
    element: CheckoutExecutePaymentWithInstallmentsPage,
    functions: [],
    pageName: 'Skeniraj - Uplata na rate'
  },
  {
    path: `${AppRoutes.MBO.fullPath}/:soId`,
    element: MboPage,
    functions: [],
    pageName: 'MBO'
  },
  {
    path: `${AppRoutes.MBO_THANK_YOU.fullPath}`,
    element: MboThankYouPage,
    functions: [],
    pageName: 'MBO Thank You'
  }
];

export default AppRouting;